import React from 'react';

import { FormattedMessage } from 'react-intl';
import { KitIcons } from '@repo/apg-ui';

const icons = KitIcons.productIcons;

export const getIcon = (format) => {
  return icons[format];
};

export const salutation = {
  1: <FormattedMessage id='ec.general.mr' defaultMessage='Herr' />,
  0: <FormattedMessage id='ec.general.mrs' defaultMessage='Frau' />,
};

export const spottypes = {
  1: {
    id: '1',
    name: <FormattedMessage id='ec.creationOrder.standbild' defaultMessage='Standbild' />,
    link: 'https://apgwebsite2021privatecloud-live-e989965-f00c998.divio-media.org/filer_public/0c/cf/0ccf3707-f3a2-42a6-b36e-341a21eaef1f/standbild.mp4',
  },
  2: {
    id: '2',
    name: <FormattedMessage id='ec.creationOrder.animation' defaultMessage='Leichte Animation' />,
    link: 'https://apgwebsite2021privatecloud-live-e989965-f00c998.divio-media.org/filer_public/70/cc/70cc865d-eb5e-4150-8c4c-77dbd466b389/limited_animation_coke.mp4',
  },
  3: {
    id: '3',
    name: <FormattedMessage id='ec.creationOrder.2dMotionDesign' defaultMessage='2D-Animation' />,
    link: 'https://apgwebsite2021privatecloud-live-e989965-f00c998.divio-media.org/filer_public/bd/de/bddefa4b-dfc6-486e-8613-9f0cc584d5e8/2d_pkzcouple.mp4',
  },
  4: {
    id: '4',
    name: <FormattedMessage id='ec.creationOrder.3dMotionDesign' defaultMessage='3D-Animation' />,
    link: 'https://apgwebsite2021privatecloud-live-e989965-f00c998.divio-media.org/filer_public/5d/cb/5dcbb08e-2b2f-4dc8-84b1-6f39b8690f86/3d_coke.mp4',
  },
  5: {
    id: '5',
    name: <FormattedMessage id='ec.creationOrder.video' defaultMessage='Full-Motion-Animation' />,
    link: 'https://apgwebsite2021privatecloud-live-e989965-f00c998.divio-media.org/filer_public/97/32/9732ba22-1a8f-4d51-8ca9-9fb1f3d6f8c6/fullmotion_coke.mp4',
  },
};
